import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_HOME_REVIEWABLE_MEALS = 'GET_HOME_REVIEWABLE_MEALS';
export const GET_HOME_REVIEWABLE_MEALS_REQUEST = 'GET_HOME_REVIEWABLE_MEALS_REQUEST';
export const GET_HOME_REVIEWABLE_MEALS_RESPONSE = 'GET_HOME_REVIEWABLE_MEALS_RESPONSE';
export const GET_HOME_REVIEWABLE_MEALS_ERROR = 'GET_HOME_REVIEWABLE_MEALS_ERROR';

export const getHomeReviewableMeals = () =>
  makeApiRequest({
    requestType: GET_HOME_REVIEWABLE_MEALS,
    method: RequestService.getHomeReviewableMeals,
  });
